/**
 * Star-Naming.com — Landing Home JS
 * Spec: SHOPIFY-LP-SPEC.md §23
 * Behaviors added section-by-section as they are built.
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ---------- Topbar rotation (6s, sequential fade) + fixed-head spacer ---------- */
  function initTopbar() {
    var head = document.querySelector('.lp-stickyhead');
    function syncHeadHeight() {
      if (!head) return;
      var h = Math.ceil(head.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--lp-head-h', h + 'px');
    }
    syncHeadHeight();
    window.addEventListener('resize', syncHeadHeight, { passive: true });

    var msgs = Array.prototype.slice.call(document.querySelectorAll('.lp-topbar .msg'));
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      setTimeout(function () {
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('on');
      }, 480);
    }, 6000);
  }

  /* ---------- Active nav highlighting (IntersectionObserver) ---------- */
  function initActiveNav() {
    var links = Array.prototype.slice.call(document.querySelectorAll('.lp-nav [data-nav]'));
    if (!links.length || !('IntersectionObserver' in window)) return;

    var map = {};
    links.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (id) map[id] = a;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          if (!map[id]) return;
          links.forEach(function (l) {
            l.classList.remove('active');
          });
          map[id].classList.add('active');
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );

    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el);
    });
  }

  /* ---------- UGC marquee: duplication fallback + offscreen pause ---------- */
  function initUgcStrip() {
    var track = document.querySelector('[data-lp-ugc-track]');
    if (!track) return;

    // The section now renders both halves in Liquid (data-lp-duplicated="1") so
    // the -50% loop is seamless from first paint. Keep the JS duplication only
    // as a fallback for older markup.
    if (track.dataset.lpDuplicated !== '1' && track.children.length) {
      track.innerHTML += track.innerHTML;
      track.dataset.lpDuplicated = '1';
    }

    // Pause the animation while the strip is offscreen — Chrome keeps
    // compositing infinite transform animations otherwise.
    if ('IntersectionObserver' in window && track.dataset.lpUgcIo !== '1') {
      track.dataset.lpUgcIo = '1';
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          track.classList.toggle('lp-ugc-offscreen', !en.isIntersecting);
        });
      }).observe(track);
    }
  }

  /* ---------- TrustBox: hide static fallback when iframe loads ---------- */
  function initTrustpilotFallback() {
    var w = document.getElementById('lp-tpbox');
    var fb = document.getElementById('lp-tp-fallback');
    if (!w || !fb) return;
    var n = 0;
    var t = setInterval(function () {
      if (w.querySelector('iframe')) {
        fb.style.display = 'none';
        clearInterval(t);
      } else if (++n > 25) {
        clearInterval(t);
      }
    }, 300);
  }

  /* ---------- Offer image: copy from Premium Star Map tile when present ---------- */
  function initOfferImageCopy() {
    var oi = document.querySelector('[data-lp-offer-img]');
    if (!oi) return;
    var sm = document.querySelector('[data-lp-star-map]');
    if (!sm || !sm.src) return;
    oi.src = sm.src;
    if (sm.srcset) oi.srcset = sm.srcset;
    oi.hidden = false;
    oi.removeAttribute('hidden');
  }

  /* ---------- Package details: open on desktop, closed on mobile ---------- */
  function initPackageDetails() {
    if (window.innerWidth <= 960) return;
    document.querySelectorAll('.lp-card-details').forEach(function (d) {
      d.open = true;
    });
  }

  /* ---------- Video click-to-play (poster → <video>) ---------- */
  function playVidCard(card) {
    var src = card.getAttribute('data-src');
    if (!src || card.querySelector('video')) return;
    var vid = document.createElement('video');
    vid.src = src;
    vid.controls = true;
    vid.autoplay = true;
    vid.playsInline = true;
    card.innerHTML = '';
    card.appendChild(vid);
  }

  function initVideoClickToPlay() {
    document.querySelectorAll('[data-lp-vid]').forEach(function (card) {
      card.addEventListener('click', function () {
        playVidCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          playVidCard(card);
        }
      });
    });
  }

  /* ---------- Hero slider: auto-advance + dots + quote (pauses on interaction) ---------- */
  function initHeroSlider() {
    document.querySelectorAll('[data-lp-hs-track]').forEach(function (track) {
      if (track.dataset.lpHsInit === '1') return;
      var n = track.children.length;
      if (n < 2) return;
      var slider = track.parentElement;
      var dotsWrap = slider && slider.querySelector('[data-lp-hs-dots]');
      var heroimg = track.closest('.lp-heroimg');
      var quoteCard = heroimg && heroimg.querySelector('[data-lp-hs-quote]');
      if (!dotsWrap) return;

      track.dataset.lpHsInit = '1';
      var i = 0;
      var paused = false;
      var scrollingTo = null;
      var quoteTimer = null;

      dotsWrap.innerHTML = '';
      for (var k = 0; k < n; k++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Slide ' + (k + 1));
        if (k === 0) btn.className = 'on';
        btn.addEventListener(
          'click',
          (function (idx) {
            return function () {
              goTo(idx, true);
              pauseFor(9000);
            };
          })(k)
        );
        dotsWrap.appendChild(btn);
      }

      var dots = Array.prototype.slice.call(dotsWrap.children);

      function syncDots() {
        dots.forEach(function (dot, j) {
          dot.classList.toggle('on', j === i);
        });
      }

      function syncQuote() {
        if (!quoteCard) return;
        var img = track.children[i];
        if (!img) return;
        var q = img.getAttribute('data-lp-quote') || '';
        var who = img.getAttribute('data-lp-who') || '';
        var verified = img.getAttribute('data-lp-verified') || '';
        var textEl = quoteCard.querySelector('[data-lp-hs-quote-text]');
        var whoEl = quoteCard.querySelector('[data-lp-hs-quote-who]');
        var verWrap = quoteCard.querySelector('[data-lp-hs-quote-verified-wrap]');
        var verEl = quoteCard.querySelector('[data-lp-hs-quote-verified]');

        function apply() {
          if (textEl) textEl.textContent = q ? '“' + q + '”' : '';
          if (whoEl) whoEl.textContent = who;
          if (verEl) verEl.textContent = verified;
          if (verWrap) {
            if (verified) verWrap.removeAttribute('hidden');
            else verWrap.setAttribute('hidden', '');
          }
          quoteCard.classList.remove('is-fading');
        }

        if (quoteTimer) clearTimeout(quoteTimer);
        quoteCard.classList.add('is-fading');
        quoteTimer = setTimeout(apply, 160);
      }

      function goTo(idx, scroll) {
        if (idx < 0 || idx >= n) return;
        i = idx;
        if (scroll) {
          scrollingTo = idx;
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        }
        syncDots();
        syncQuote();
      }

      function pauseFor(ms) {
        paused = true;
        setTimeout(function () {
          paused = false;
        }, ms);
      }

      track.addEventListener(
        'scroll',
        function () {
          var k = Math.round(track.scrollLeft / track.clientWidth);
          if (scrollingTo !== null) {
            if (k === scrollingTo) scrollingTo = null;
            return;
          }
          if (k !== i) {
            i = k;
            syncDots();
            syncQuote();
          }
        },
        { passive: true }
      );

      ['touchstart', 'pointerdown'].forEach(function (ev) {
        track.addEventListener(
          ev,
          function () {
            scrollingTo = null;
            pauseFor(9000);
          },
          { passive: true }
        );
      });

      setInterval(function () {
        if (!track.isConnected) return;
        if (paused || document.hidden) return;
        goTo((i + 1) % n, true);
      }, 3500);
    });
  }

  /* ---------- Sticky mobile CTA: two-phase (hero → packs → bestseller) ---------- */
  function initStickyCta() {
    var bar = document.querySelector('[data-lp-msticky]');
    if (!bar || bar.dataset.lpStickyInit === '1') return;
    bar.dataset.lpStickyInit = '1';
    var link = bar.querySelector('[data-lp-msticky-link]');
    var label = bar.querySelector('[data-lp-msticky-label]');
    var price = bar.querySelector('[data-lp-msticky-price]');
    var hero = document.getElementById('hero') || document.querySelector('.lp-hero');
    if (!link || !label || !price || !hero) return;

    // plus-scripts.js binds preventDefault to every a[href*="#"] at page load.
    // This sticky link starts as #gift-sets, so that listener stays attached even
    // after we switch href to the bestseller URL — clone strips those listeners.
    var fresh = link.cloneNode(true);
    link.parentNode.replaceChild(fresh, link);
    link = fresh;
    label = link.querySelector('[data-lp-msticky-label]') || label;
    price = link.querySelector('[data-lp-msticky-price]') || price;

    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') {
        e.preventDefault();
        var id = href.slice(1);
        var target = id ? document.getElementById(id) : null;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // Non-hash URL (phase 2 bestseller) — force navigation in case any leftover
      // hash handler called preventDefault before this listener runs.
      e.preventDefault();
      window.location.assign(href);
    });

    var mq = window.matchMedia('(max-width: 960px)');
    var phase = 0;
    var ticking = false;

    function setPhase(n) {
      if (phase === n) return;
      phase = n;
      var p = 'data-phase' + n + '-';
      var fallback = n === 2 ? '/pages/star-configurator/supernova' : '#gift-sets';
      label.textContent = bar.getAttribute(p + 'label') || '';
      price.textContent = bar.getAttribute(p + 'price') || '';
      link.setAttribute('href', bar.getAttribute(p + 'href') || fallback);
    }

    // Gorgias injects its launcher long after DOMContentLoaded, so re-query until
    // it turns up. The launcher is the iframe inside #gorgias-chat-container; the
    // container itself is the fallback for older/other widget markup.
    var chatEl = null;
    function chatLauncher() {
      if (chatEl && chatEl.isConnected) return chatEl;
      chatEl =
        document.querySelector('#gorgias-chat-container iframe#chat-button') ||
        document.querySelector('iframe#chat-button') ||
        document.querySelector('#gorgias-chat-container');
      if (chatEl) chatEl.classList.add('lp-chat-shiftable');
      return chatEl;
    }

    function setVisible(on) {
      bar.classList.toggle('lp-msticky-on', on);
      var chat = chatLauncher();
      if (chat) chat.classList.toggle('lp-chat-lifted', on);
    }

    function update() {
      ticking = false;
      if (!bar.isConnected) return;
      if (!mq.matches) {
        bar.setAttribute('hidden', '');
        setVisible(false);
        return;
      }
      bar.removeAttribute('hidden');

      // Viewport-relative, NOT a fraction of the hero height: on mobile the hero
      // stacks (copy + square image + quote card) and gets far taller than the
      // screen, so "bottom < height * 0.4" fired while the hero was still filling
      // the viewport. Only show once the hero has scrolled off the top.
      var heroRect = hero.getBoundingClientRect();
      var pastHero = heroRect.bottom <= 0;

      // gift-sets may not exist on every page — fall back to phase 1 only
      var packs = document.getElementById('gift-sets');
      var packsVisible = false;
      var pastPacks = false;
      if (packs) {
        var pr = packs.getBoundingClientRect();
        packsVisible = pr.top < window.innerHeight && pr.bottom > 0;
        pastPacks = pr.bottom <= 0;
      }

      setPhase(pastPacks ? 2 : 1);
      setVisible(pastHero && !packsVisible);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(update);
      else update();
    }

    // capture:true also catches scrolls inside nested scroll containers,
    // so the bar keeps working if a wrapper (not the window) does the scrolling
    document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    // iOS Safari collapses/expands the address bar without firing window
    // resize or scroll — visualViewport is the only reliable signal there.
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestUpdate, { passive: true });
      window.visualViewport.addEventListener('scroll', requestUpdate, { passive: true });
    }
    if (mq.addEventListener) mq.addEventListener('change', requestUpdate);
    else if (mq.addListener) mq.addListener(requestUpdate);
    // The hero grows after first paint (fonts, and wp-page-speed-optimization
    // swaps the hero image src on scroll). Without this the bar keeps a stale
    // "past hero" decision while the hero is back on screen.
    window.addEventListener('load', requestUpdate);
    if (window.ResizeObserver) new window.ResizeObserver(requestUpdate).observe(hero);
    update();
  }

  onReady(function () {
    initTopbar();
    initActiveNav();
    initUgcStrip();
    initTrustpilotFallback();
    initOfferImageCopy();
    initPackageDetails();
    initVideoClickToPlay();
    initHeroSlider();
    initStickyCta();
  });

  // Theme editor re-renders sections without re-running DOMContentLoaded —
  // re-bind the sticky CTA when its section (or any section) reloads.
  document.addEventListener('shopify:section:load', function () {
    initStickyCta();
    initUgcStrip();
    initOfferImageCopy();
    initHeroSlider();
  });
})();
